import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { setChannelMessageReply } from "../../../../../redux/actions";
import EmojiPicker from "../picker/emoji";
import { Box } from "@mui/system";
import {
  setShowThread,
  setCreateMessageThreadId,
  setSelectedThread,
  setChannelThreadMessageReply,
} from "../../../../../redux/slices/community";

const ThreadMessageActionButton = ({
  item,
  user,
  handleDelete,
  handleReaction,
  handleShowThread,
  handleThreadMessageReport1,
  handleEdit,
  isMobile,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const userRole = localStorage.getItem("userRole");
  const { userData } = useSelector((state) => state.user);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };
  const dispatch = useDispatch();
  const onClickReply = (e) => {
    e.preventDefault();
    console.log("reply to item :", item);
    // dispatch(setChannelMessageReply(item));
    dispatch(setChannelThreadMessageReply(item));
  };
  const onClickThread = (e) => {
    e.preventDefault();
    dispatch(setSelectedThread(null));
    dispatch(setCreateMessageThreadId(item?._id));
    dispatch(setShowThread(true));
  };
  const onSelectEmoji = (e) => {
    console.log("Print thread message reaction:", e);
    handleReaction(e);
    dispatch(setChannelMessageReply(null));
  };

  return (
    <>
      {!isMobile && (
        <div className="action icon-delete">
          <EmojiPicker onSelectEmoji={onSelectEmoji} reaction={true} />
          <button
            type="button"
            aria-label="Reply"
            className="hint hint-bottom"
            onClick={onClickReply}
            disabled={userData?.community_status?.banned == true}
          >
            <img src="/images/community/reply-icon.svg" />
          </button>
          {(item?.user?._id === user?.userId || userData?.role == "admin") && (
            <>
              {/* {userRole == "admin" && !item?.isThread && (
                <button
                  type="button"
                  aria-label="Create Thread"
                  className="hint hint-bottom"
                  onClick={onClickThread}
                >
                  <img src="/images/community/create-thread.svg" />
                </button>
              )} */}
              {item?.user?._id === user?.userId && (
                <button
                  type="button"
                  aria-label="Edit"
                  className="hint hint-bottom"
                  onClick={handleEdit}
                  disabled={userData?.community_status?.banned == true}
                >
                  <img src="/images/community/edit-icon.svg" />
                </button>
              )}
              <button
                type="button"
                aria-label="Delete"
                className="hint hint-bottom"
                onClick={handleDelete}
                disabled={userData?.community_status?.banned == true}
              >
                <img src="/images/community/delete-icon.svg" />
              </button>
            </>
          )}
          {item?.user?._id != user?.userId && (
            <button
              type="button"
              aria-label="Flag Content"
              className="hint hint-bottom"
              onClick={handleThreadMessageReport1}
              disabled={userData?.community_status?.banned == true}
            >
              <img
                src="/images/community/flag1.jpeg"
                style={{
                  height: "22px",
                  width: "22px",
                  background: "#fff",
                }}
              />
            </button>
          )}
        </div>
      )}
      {isMobile && (
        <div
          className="action icon-ellipsis"
          style={{
            padding: "0px",
            border: "0px",
          }}
        >
          <Box
            style={{
              width: "30px",
              height: "30px",
              border: "0px",
              justifyContent: "center",
              alignContent: "center",
              display: "flex",
              flex: 1,
            }}
            onClick={handleClick}
            disabled={userData?.community_status?.banned == true}
          >
            <button
              type="button"
              id="basic-button"
              className="more_action"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              // onClick={handleDelete}
              disabled={userData?.community_status?.banned == true}
            >
              {/* <img src="/images/community/delete-icon.svg" /> */}
              <i className="fa fa-ellipsis-v"></i>
            </button>
          </Box>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={() => {}}>
              <EmojiPicker onSelectEmoji={onSelectEmoji} reaction={true} />
            </MenuItem>
            <MenuItem onClick={() => {}}>
              <button
                type="button"
                className="btn-default hint hint-bottom"
                onClick={onClickReply}
                aria-label="Reply"
                disabled={userData?.community_status?.banned == true}
              >
                <img src="/images/community/reply-icon.svg" />
              </button>
            </MenuItem>
            {item?.user?._id != user?.userId && (
              <MenuItem onClick={() => {}}>
                <button
                  type="button"
                  className="btn-default hint hint-bottom1"
                  onClick={handleThreadMessageReport1}
                  aria-label="Flag Content"
                  disabled={userData?.community_status?.banned == true}
                >
                  <img
                    src="/images/community/flag1.jpeg"
                    style={{ height: "22px", width: "22px" }}
                  />
                </button>
              </MenuItem>
            )}
            {(item?.user?._id === user?.userId ||
              userData?.role == "admin") && (
              <>
                {item?.user?.id === user?.userId && (
                  <MenuItem onClick={() => {}}>
                    <button
                      type="button"
                      className="btn-default hint hint-bottom"
                      onClick={handleEdit}
                      disabled={userData?.community_status?.banned == true}
                      aria-label="Edit"
                    >
                      <img src="/images/community/edit-icon.svg" />
                    </button>
                  </MenuItem>
                )}
                <MenuItem onClick={() => {}}>
                  <button
                    type="button"
                    className="btn-default hint hint-bottom"
                    onClick={handleDelete}
                    disabled={userData?.community_status?.banned == true}
                    aria-label="Delete"
                  >
                    <img src="/images/community/delete-icon.svg" />
                  </button>
                </MenuItem>
              </>
            )}
          </Menu>
        </div>
      )}
    </>
  );
};

export default ThreadMessageActionButton;
